// Libs
import React from 'react'

// CSS
import "./styles.scss"

import { Bookmark } from 'react-feather'

const SwapCard = ({ operation, pinOperation, userId, data, swapOperation, history }) => {

  return (
    <div title={operation.label} className={operation.current ? 'swap-bar-operation swap-bar-operation--current' : 'swap-bar-operation'} onClick={() => swapOperation(data, userId, history)}>
      <div className='swap-bar-operation-title'>
        <p>{operation.label}</p>
        <div className='swap-bar-operation-title-pendencies'>
          {operation.pin ? <div>NEG <span>{operation.negotiation}</span> FIN <span>{operation.finalization}</span> PRO<span>{operation.awaitingProtocol}</span></div> :
            <div>{operation.type === 'group' ? 'GRUPO' : 'ESCRITÓRIO'}</div>
          }
        </div>
      </div>
      <Bookmark size={22} className={operation.pin ? 'swap-bar-operation-pin swap-bar-operation-pin--selected' : 'swap-bar-operation-pin'}
        onClick={(e) => {
          pinOperation(userId, operation.value, !operation.pin, operation.type)
          e.stopPropagation()
        }}>
      </Bookmark>
    </div>
  )
}

export default SwapCard
